"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var font = require("@headspace/hs-web-style-guide/dist/font");

var spacing = require("@headspace/hs-web-style-guide/dist/spacing");

var breakpoints = require("@headspace/hs-web-style-guide/dist/breakpoints");

var flex = require('@headspace/hs-web-style-guide/dist/flex').default;

exports.radioWrapperStyles = hs_web_style_guide_1.css(flex.flex, flex.justifyContentSpaceBetween);

exports.labelStyles = function (color) {
  var _a;

  return hs_web_style_guide_1.css(font.p3, flex.flex1, flex.justifyContentSpaceBetween, (_a = {
    color: color
  }, _a[breakpoints.maxWidths.l] = {
    fontSize: 16,
    lineHeight: '24px'
  }, _a));
};

exports.valueStyles = hs_web_style_guide_1.css(font.p3, spacing.default.paddingBottomXxxsmall, {
  color: colors_1.comet
});
exports.selectOptionStyle = hs_web_style_guide_1.css({
  color: colors_1.comet,
  fontSize: 16,
  textDecoration: 'none',
  zIndex: 1
});

exports.selectFieldStyle = function (minWidth) {
  return hs_web_style_guide_1.css({
    minWidth: minWidth,
    outline: 'none'
  });
};

exports.selectFieldTextStyle = hs_web_style_guide_1.css(font.p3, {
  backgroundColor: 'transparent',
  color: colors_1.comet,
  border: 'none'
});
exports.radioButtonStyle = hs_web_style_guide_1.css(spacing.default.marginRightXsmall, spacing.default.marginLeftXsmall, {
  height: 25,
  width: 25,
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  appearance: 'none',
  borderRadius: 25,
  outline: 'none',
  border: "2px solid " + colors_1.carrarra,
  ':checked': {
    border: "8px solid " + colors_1.fountainBlue
  }
});